import { render, staticRenderFns } from "./ClipperImage.vue?vue&type=template&id=0f1671be"
import script from "./ClipperImage.vue?vue&type=script&lang=js"
export * from "./ClipperImage.vue?vue&type=script&lang=js"
import style0 from "./ClipperImage.vue?vue&type=style&index=0&id=0f1671be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports